import { render, staticRenderFns } from "./sales-statistical-charts.vue?vue&type=template&id=396ae1d4&scoped=true"
import script from "./sales-statistical-charts.vue?vue&type=script&lang=js"
export * from "./sales-statistical-charts.vue?vue&type=script&lang=js"
import style0 from "./sales-statistical-charts.vue?vue&type=style&index=0&id=396ae1d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396ae1d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396ae1d4')) {
      api.createRecord('396ae1d4', component.options)
    } else {
      api.reload('396ae1d4', component.options)
    }
    module.hot.accept("./sales-statistical-charts.vue?vue&type=template&id=396ae1d4&scoped=true", function () {
      api.rerender('396ae1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stat-analyze/sales-statistical-charts/sales-statistical-charts.vue"
export default component.exports